module.exports = __webpack_public_path__ + "img/img_poa_reflective.ae8c9d69.png";